import { createSubtemplate } from "@repo/design-system/lib/client-registry";
import type { SectionKey } from "~/components/job-page/jobpagetemplate/unified-jobpage-template";
import AboutEonGridsolutions from "~/components/job-page/subclients/eon-gridsolutions/about-eon-gridsolutions";
import BenefitsEonGridsolutions from "~/components/job-page/subclients/eon-gridsolutions/benefits-eon-gridsolutions";
import CompanyEonGridsolutions from "~/components/job-page/subclients/eon-gridsolutions/company-eon-gridsolutions";
import ContactEonGridsolutions from "~/components/job-page/subclients/eon-gridsolutions/contact-eon-gridsolutions";
import HeaderImageEonGridsolutions from "~/components/job-page/subclients/eon-gridsolutions/headerimage-eon-gridsolutions";
import JobAdTemplateEonGridsolutions from "~/components/job-page/subclients/eon-gridsolutions/jobad-template-eon-gridsolutions";
import SloganPictureEonGridsolutions from "~/components/job-page/subclients/eon-gridsolutions/slogan-picture-eon-gridsolutions";

/**
 * EON Grid Solutions client template for the EON registry.
 *
 * This allows eon-gridsolutions jobs to be displayed with eon-gridsolutions styling
 * when accessed via the eon jobboard (jobs.eon.com), since eon-gridsolutions doesn't
 * have its own separate jobboard.
 *
 */
export const eonGridsolutionsDefault = createSubtemplate<SectionKey>({
  name: "eon-gridsolutions",
  trigger: () => true,
  showProd: true,
  config: {
    overrides: {
      headerImage: HeaderImageEonGridsolutions,
      jobDescription: JobAdTemplateEonGridsolutions,
      contact: ContactEonGridsolutions,
      companyInfo: CompanyEonGridsolutions,
      benefits: BenefitsEonGridsolutions,
      about: AboutEonGridsolutions,
      sloganPicture: SloganPictureEonGridsolutions,
      // printView uses default eon component (no customization needed)
    },
    sections: [
      "stickyContact",
      "headerImage",
      "breadcrumb",
      "companyInfo",
      "jobDescription",
      "contact",
      "applicationProcess",
      "diversity",
      "sloganPicture",
      "about",
      "benefits",
      "similarJobs",
      "printView",
    ],
  },
});
